import React, { useState, useContext } from "react";
import "./ArchiveSearchBar.scss";

import { Button, Input, Form } from 'antd';
import { getIcon } from "../../../utils/images";
import Filters from "../../Filters/Filters";
import FilterCounterContext from "../../Filters/FilterCounterContext";

const ArchiveSearchBar = ({ form, filterBookingNumber, filterList, setFilterList }) => {
  const [showFiltersForm, setShowFiltersForm] = useState(false)

  function closeHeader() {
    setShowFiltersForm(false)
  }

  function openHeader() {
    setShowFiltersForm(true)
  }

  const { filterCounter } = useContext(FilterCounterContext);


  return (
    <div className="ArchiveSearchBar">
      <div className="filters">

        <Form
          name="booking filter"
          onFinish={filterBookingNumber}
          autoComplete="off"
          form={form}
        >

          <Form.Item name="booking_number">
            <div className="booking-search-wrapper">
              <Input
                className="booking-search-input"
                placeholder="Bk No # / BL / Client Ref"
                onPressEnter={filterBookingNumber} />
            </div>
          </Form.Item>
        </Form>

        <div className="vertical-line">
        </div>
        <div>
          <Button onClick={openHeader}>
            <div className="filter-decoration" data-count={filterCounter}>
              <img src={getIcon('filter')} />
            </div>
          </Button>
        </div>
      </div>

      {showFiltersForm && <Filters close={closeHeader} setFilterList={setFilterList} filterList={filterList} archive={true} />}
    </div>
  )
};

export default ArchiveSearchBar;
